import { useMemo } from 'react';
import { getRegisterAuthToken, getTokenVariable } from '../../cookies';
import { useStaffSessionStore } from '../../store';

export const useAuthState = () => {
    const hasBranchAuthToken = useMemo(() => {
        return !!getTokenVariable();
    }, []);

    const hasRegisterAuthToken = useMemo(() => {
        return !!getRegisterAuthToken();
    }, []);

    const staffId = useStaffSessionStore((s) => s.staffId);
    const staffSignature = useStaffSessionStore((s) => s.staffSignature);

    const hasLoggedIn = !!staffId && !!staffSignature;

    return {
        hasRegisterAuthToken,
        hasBranchAuthToken,
        hasLoggedIn,
    };
};
